var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadiation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#ff462e}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "radiation",
    transform: "translate(.016 .001)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#ffce6e",
    transform: "translate(-.016 -.001)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1472",
    transform: "translate(3.944 8.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    d: "M214.74 209.467a5.47 5.47 0 1 1-5.47 5.47 5.472 5.472 0 0 1 5.47-5.47z",
    className: "cls-2",
    transform: "translate(-188.657 -193.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    d: "M169.72 325.822l6.438 11.407a2.53 2.53 0 0 1-1.19 3.566 26.3 26.3 0 0 1-21-.1 2.532 2.532 0 0 1-1.16-3.58l6.549-11.344a2.524 2.524 0 0 1 2.9-1.167 8.262 8.262 0 0 0 4.578.026 2.531 2.531 0 0 1 2.885 1.192z",
    className: "cls-2",
    transform: "translate(-138.498 -295.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    d: "M316.982 95.629H303.86a2.515 2.515 0 0 1-2.434-1.944 8.2 8.2 0 0 0-2.267-3.957 2.527 2.527 0 0 1-.411-3.1l6.652-11.275a2.537 2.537 0 0 1 3.706-.736 26.321 26.321 0 0 1 6.579 7.154 26.047 26.047 0 0 1 3.815 11.065 2.532 2.532 0 0 1-2.518 2.793z",
    className: "cls-2",
    transform: "translate(-267.35 -74.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    d: "M53.509 89.717a8.2 8.2 0 0 0-2.267 3.957 2.515 2.515 0 0 1-2.434 1.944H35.686a2.535 2.535 0 0 1-2.519-2.805 26.083 26.083 0 0 1 5.121-12.963 26.37 26.37 0 0 1 5.279-5.25 2.533 2.533 0 0 1 3.7.744l6.653 11.275a2.527 2.527 0 0 1-.411 3.098z",
    className: "cls-2",
    transform: "translate(-33.152 -74.095)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiation);
export default __webpack_public_path__ + "static/media/radiation.9a90a7edbf34797629250fa64cda6ba6.svg";
export { ForwardRef as ReactComponent };